// src/components/TextoExpandible.tsx
//
// Texto con truncado + "leer más" (descripciones largas de servicios).
// Vivía adentro de PublicProfessionalLanding; salió a su archivo porque lo usan
// la lista de servicios y el selector de servicios del modal de reserva.
//
// No usar dentro de un <button>: el "leer más" es otro botón y quedaría
// anidado.

import React, { useState } from 'react';

interface Props {
  text: string;
  limit?: number;
  className?: string;
}

const TextoExpandible: React.FC<Props> = ({ text, limit = 110, className = '' }) => {
  const [expanded, setExpanded] = useState(false);
  if (!text) return null;
  const isLong = text.length > limit;
  const shown = expanded || !isLong ? text : text.slice(0, limit).trimEnd() + '…';
  return (
    <p className={className}>
      {shown}
      {isLong && (
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); setExpanded(!expanded); }}
          className="ml-1 text-blue-600 hover:text-blue-700 font-medium"
        >
          {expanded ? 'leer menos' : 'leer más'}
        </button>
      )}
    </p>
  );
};

export default TextoExpandible;
